export enum RequestOrigin {
    EasyWeb = 'EasyWeb',
    CustomerApp = 'CustomerApp',
    TotemApp = 'TotemApp',
    GestorApp = 'GestorApp',
    MarinheiroApp = 'MarinheiroApp'
}

